<dc-navbar-default
  [useOnlyDarkLogo]="true"
  [position]="'right'"
></dc-navbar-default>

<main class="position-relative overflow-hidden">
  <dc-smart-business-heading></dc-smart-business-heading>
  <dc-slider-card-projects [liftUp]="false"></dc-slider-card-projects>

  <dc-smart-business-why-dashcore></dc-smart-business-why-dashcore>
  <dc-counter5></dc-counter5>
  <dc-smart-business-deserve-better></dc-smart-business-deserve-better>
  <dc-integration-floating-icons></dc-integration-floating-icons>
  <dc-testimonial-single-boxed></dc-testimonial-single-boxed>

  <dc-slider-icons
    [background]="'light'"
    [edge]="'top-left'"
    [bordered]="false"
    [title]="'Featured in'"
  ></dc-slider-icons>

  <dc-faqs1 [background]="'light'"></dc-faqs1>

  <dc-cta1 [background]="'contrast'" [edge]="'top-left'"></dc-cta1>

  <dc-footer1></dc-footer1>
</main>
